import * as tslib_1 from "tslib";
// Core packages
import { formatDate, formatNumber } from "@angular/common";
import { AfterViewInit, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import * as FileSaver from "file-saver";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { forkJoin } from "rxjs";
import { distinctUntilChanged, finalize, startWith, take } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { BalancesService } from "src/app/modules/balances/balances.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { DeadlinesService } from "src/app/modules/deadlines/deadlines.service";
import { PricesService } from "src/app/modules/prices/prices.service";
import { ExportContractsDialogComponent } from "src/app/modules/properties/components/export-contracts-dialog/export-contracts-dialog.component";
import { ExportRasDocsDialogComponent } from "src/app/modules/properties/components/export-ras-docs-dialog/export-ras-docs-dialog.component";
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import DocumentTypeStructure from "src/app/modules/properties/documentTypes";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { StatementsService } from "src/app/modules/properties/statements.service";
import { SubscriptionsService } from "src/app/modules/subscriptions/subscriptions.service";
import { SuppliersService } from "src/app/modules/suppliers/suppliers.service";
import { UsersService } from "src/app/modules/users/users.service";
import { AddCommunicationDialogComponent } from "src/app/shared/components/dialogs/add-communication-dialog/add-communication-dialog.component";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { Company } from "src/app/shared/models/company/company.model";
import { Property } from "src/app/shared/models/property/property.model";
import { User } from "src/app/shared/models/user/user.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ListsService } from "src/app/shared/services/lists.service";
import { ThemeService } from "src/app/shared/services/theme.service";
var PropertyCondominiumAccessComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyCondominiumAccessComponent(dialog, newMessageDialog, cancelContractDialog, configService, activatedRoute, propertiesService, router, toastrService, helperService, translateService, themeService, authService, cookieService, companiesService, apiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    subscriptionsService, pricesService, balancesService, listsService, userService, deadlinesService, suppliersService, documentArchivesService, condoStructuresService, statementsService) {
        this.dialog = dialog;
        this.newMessageDialog = newMessageDialog;
        this.cancelContractDialog = cancelContractDialog;
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.propertiesService = propertiesService;
        this.router = router;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.companiesService = companiesService;
        this.apiService = apiService;
        this.subscriptionsService = subscriptionsService;
        this.pricesService = pricesService;
        this.balancesService = balancesService;
        this.listsService = listsService;
        this.userService = userService;
        this.deadlinesService = deadlinesService;
        this.suppliersService = suppliersService;
        this.documentArchivesService = documentArchivesService;
        this.condoStructuresService = condoStructuresService;
        this.statementsService = statementsService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // Could not be "Property" type because in "get" method in the back-end
        // We are populating some fields, so the model is not the same!
        this.property = new Property();
        this.propertyId = "";
        this.loggedUserShared = false;
        this.loggedUserMaster = false;
        this.loggedUserAdmin = false;
        this.detailCardIsLoading = true;
        this.deleteCardIsLoading = true;
        this.sharedUserCardIsLoading = true;
        this.phonebookCardIsLoading = true;
        this.loggedUserRoleType = "";
        this.subscriptionDocumentUpload = false;
        // BEGIN - Edit property form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.formSC = new FormGroup({});
        this.formSP = new FormGroup({});
        this.model = {};
        this.modelSC = {};
        this.modelSP = {};
        this.anagraphicFields = [];
        this.contractFields = [];
        this.statusFields = [];
        this.options = {};
        this.formSharedUser = new FormGroup({});
        this.modelSharedUser = {};
        this.sharedUserFields = [];
        this.optionsSharedUser = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        this.formSharedUserBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        this.deleteBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.deactivate"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "warn",
            spinnerColor: "warn",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-times",
                inline: true,
            },
        };
        this.reactivateBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.activate"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-check",
                inline: true,
            },
        };
        // END - Edit property form
        this.prices = [];
        this.isInit = true;
        this.enableEdit = false;
        this.sharedUser = new User();
        this.previousPermissions = {
            unlimited: false,
            mappatura: false,
            gestionaleAmministrativo: false,
            amminImmobile: false,
            gestionaleContabile: false,
            urbanisticaEdEdilizia: false,
            catasto: false,
            contratti: false,
            lineaVita: false,
            amiantoDoc: false,
            edile: false,
            chiaviECodici: false,
            impiantoElettrico: false,
            riscaldamentoCondizionamento: false,
            ascensoriEMontauto: false,
            trattamentoAcqua: false,
            impiantiElettronici: false,
            antincendio: false,
            impiantiSpeciali: false,
            impiantiRicreativiSportivi: false,
            unitaImmobiliari: false,
            preventivi: false,
        };
        this.deadlinesCardIsLoading = true;
        this.documentTypeStructure = new DocumentTypeStructure();
        this.subscriptionType = "FREE";
        this.previousSafetyContract = {};
        this.previousAntifireContract = {};
        this.previousSubscription = {};
        this.availableTypes = [];
        this.archediSubscriptions = [];
        // List of codes
        this.firstScanCodes = this.configService.availableScanCodes;
        this.firstFixedPackCodes = this.configService.availableFixedPackageCodes;
        this.scanInsNextCodesForfait = this.configService.availableInsCodesNextForfait;
        this.scanNextCodesForfait = this.configService.availableScanCodesNextForfait;
        this.previousTotalStorageSpaceUsed = 0;
        // Dati aggiuntivi elenco/nuovo elemento
        this.suppliersName = [];
        this.yearsOfStorage = [];
        this.conductorName = [];
        this.nameInterventionArchiving = [];
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.companyName = "";
        this.companyData = {};
        this.company = new Company();
        this.mappaturaOpen = false;
        // Status card
        this.sagDate = new FormControl("");
        this.statusCardIsLoading = true;
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.propertyId = this.activatedRoute.snapshot.params.propertyId;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("properties.detail.pageTitle"));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
            var currentRole = _this.loggedUser.userRoles.find(function (obj) {
                return (obj._id.toString() ===
                    _this.authService.loggedUserRequestedRole$.getValue().toString());
            });
            _this.loggedUserRoleType = currentRole.role.type;
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        // Init areas
        this.availableTypes = this.configService.availableDocumentAreas.map(function (element) {
            return {
                value: element,
                label: _this.translateService.instant("properties.documents.areas." + element),
            };
        });
        // Se default start and end date
        this.defaultStartDate = moment().format("YYYY-MM-DD"); // .toISOString();
        this.defaultEndDate = moment()
            .add(1, "years")
            .subtract(1, "days")
            .format("YYYY-MM-DD"); // .toISOString();
        this.getPrices();
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Get logged user's role data
        this.currentRole = this.loggedUser.userRoles.find(function (obj) {
            return (obj._id.toString() ===
                _this.authService.loggedUserRequestedRole$.getValue().toString());
        });
        if (this.currentRole.role.type === "shared") {
            this.loggedUserShared = true;
        }
        if (this.currentRole.role.type === "master" ||
            this.currentRole.role.type === "collaborator") {
            this.loggedUserMaster = true;
            if (this.currentRole.company._id !== "") {
                this.subscriptions.push(this.companiesService
                    .get(this.currentRole.company._id)
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.companyData = res.data;
                        _this.company.setData(res.data);
                    }
                }));
            }
        }
        if (this.currentRole.role.type === "admin" ||
            this.currentRole.role.type === "operator") {
            this.loggedUserAdmin = true;
        }
        // Get requested property data
        this.subscriptions.push(this.propertiesService
            .get(this.activatedRoute.snapshot.params.propertyId)
            .subscribe(function (res) {
            if (res.status) {
                // V1 returns res.property, V2 returns res.data
                var propertyData = res.data || res.property;
                // Set permission data
                _this.property.setData(propertyData);
                _this.propertyData = propertyData;
                // Save adminCompanyId before initForm() can mutate the shared admin object
                var adminCompany = propertyData.admin ? propertyData.admin.company : undefined;
                _this.adminCompanyId = adminCompany && adminCompany._id
                    ? adminCompany._id
                    : adminCompany;
                for (var prop in propertyData.subscription) {
                    _this.previousSubscription[prop] = propertyData.subscription[prop];
                }
                if (_this.propertyData.subscription &&
                    _this.propertyData.subscription.key) {
                    _this.subscriptionType = _this.propertyData.subscription.key;
                    if (_this.propertyData.subscription.documentUpload) {
                        _this.subscriptionDocumentUpload = true;
                    }
                }
                if (_this.propertyData.structure) {
                    _this.subscriptions.push(_this.condoStructuresService
                        .get(_this.propertyData.structure)
                        .subscribe(function (res) {
                        if (res.status && res.data) {
                            _this.mappaturaOpen = res.data.open;
                        }
                    }, function (err) {
                        _this.helperService.handleError(err);
                    }));
                }
                // Stop loading in delete form
                _this.deleteCardIsLoading = false;
                // Get form initial values and init the form
                _this.getDataAndInitForm();
                return;
            }
            // Something bad happened
            // redirect user to home
            _this.router.navigate([_this.lang, "app", "properties", "list"]);
        }, function (err) {
            // if we came here users with given userId do not exist
            _this.router.navigate([_this.lang, "errors", "404"]);
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Get prices from backend
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.getPrices = function () {
        var _this = this;
        this.subscriptions.push(this.pricesService.getList(0, 15).subscribe(function (res) {
            if (res.status) {
                _this.prices = _this.prices.concat(res.data.items);
                _this.getSubscriptions();
            }
        }));
    };
    /**
     * Load requested subscription data
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.getSubscriptions = function () {
        var _this = this;
        this.subscriptionsService.getList().subscribe(function (res) {
            if (res.status) {
                _this.archediSubscriptions = res.data.items;
                var subscriptions = res.data.items.map(function (item) {
                    return {
                        value: item,
                        label: item.name,
                    };
                });
                _this.availableSubscriptions = subscriptions.filter(function (element) {
                    return element.value.key !== "QRANTINCENDIO";
                });
                _this.availableSubscriptionsKeys = _this.availableSubscriptions.map(function (element) {
                    return {
                        value: element.value.key,
                        label: element.value.name,
                    };
                });
                // Create an empty value
                var noSubscription = {
                    value: "noSubscription",
                    label: _this.translateService.instant("subscriptions.fields.noSubscription"),
                };
                _this.availableSubscriptionsKeys.push(noSubscription);
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Get requested initialValues for the form and than init it
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.getDataAndInitForm = function () {
        var _this = this;
        var adminCompanyId = this.property.get("admin.company._id") ||
            this.property.get("admin.company");
        var ownerId = this.property.get("owner._id");
        if (ownerId && adminCompanyId) {
            this.subscriptions.push(forkJoin(this.companiesService.get(adminCompanyId), this.companiesService.get(ownerId)).subscribe(function (res) {
                var initialAdminData;
                var initialOwnerData;
                if (res[0] && res[0].status) {
                    initialAdminData = [res[0].data];
                    _this.companyName = res[0].data.name;
                }
                if (res[1] && res[1].status) {
                    initialOwnerData = [res[1].data];
                }
                // Init edit form
                _this.initForm(initialAdminData, initialOwnerData);
                // Make detail form card visible by disabling his card-spinner
                _this.detailCardIsLoading = false;
                _this.statusCardIsLoading = false;
            }));
        }
        else if (adminCompanyId) {
            this.companiesService.get(adminCompanyId).subscribe(function (res) {
                var initialAdminData;
                if (res && res.status) {
                    initialAdminData = [res.data];
                    _this.companyName = res.data.name;
                }
                // Init edit form
                _this.initForm(initialAdminData);
                // Make detail form card visible by disabling his card-spinner
                _this.detailCardIsLoading = false;
                _this.statusCardIsLoading = false;
            });
        }
        else {
            // No admin company ID available, init form without company data
            this.initForm();
            this.detailCardIsLoading = false;
            this.statusCardIsLoading = false;
        }
        if (this.property.get("sharedUser")) {
            this.subscriptions.push(this.userService.get(this.property.get("sharedUser")).subscribe(function (res) {
                if (res.status) {
                    _this.sharedUser.setData(res.data);
                    _this.initShareUserFom();
                    _this.sharedUserCardIsLoading = false;
                    return;
                }
            }, function (err) {
                _this.router.navigate([_this.lang, "errors", "404"]);
            }));
        }
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.initForm = function (initialAdminData, initialOwnerData) {
        var _this = this;
        if (initialAdminData &&
            Array.isArray(initialAdminData) &&
            initialAdminData.length) {
            if (initialAdminData[0].subscription) {
                Object.keys(initialAdminData[0].subscription).forEach(function (key) {
                    if (key === "startDateSuppliers") {
                        _this.masterStarDateSupplier = initialAdminData[0].subscription[key];
                    }
                    if (key === "endDateSuppliers") {
                        _this.masterEndDateSupplier = initialAdminData[0].subscription[key];
                    }
                    if (key === "suppliersFee") {
                        _this.masterSuppliersFee = initialAdminData[0].subscription[key];
                    }
                });
            }
        }
        // Set model
        this.model = this.property.getData();
        this.modelSC = this.property.getData();
        if (this.modelSC.subscription.totalStorageSpaceUsed) {
            this.previousTotalStorageSpaceUsed =
                this.modelSC.subscription.totalStorageSpaceUsed;
            this.modelSC.subscription.totalStorageSpaceUsed = formatNumber(this.modelSC.subscription.totalStorageSpaceUsed, "it-IT");
        }
        if (this.propertyData.propertyStatus &&
            this.propertyData.propertyStatus.mappingCompleted &&
            this.propertyData.propertyStatus.mappingCompleted.user) {
            this.propertyData.propertyStatus.mappingCompleted.username = this.propertyData.propertyStatus.mappingCompleted.user.firstName + " " + this.propertyData.propertyStatus.mappingCompleted.user.lastName;
        }
        this.propertyData.propertyStatus.startDate.date =
            this.propertyData.subscription.startDate;
        this.modelSP.propertyStatus = this.propertyData.propertyStatus;
        // For price list sorting
        var index = 0;
        // Minimum char amount to activate search filtering
        var minTermLength = 1;
        // Set price
        if (this.modelSC.subscription.prices) {
            this.modelSC.subscription.prices.forEach(function (elem, index) {
                switch (index) {
                    case 0:
                        _this.modelSC.subscription.price1 = { discount: elem.discount };
                        break;
                    case 1:
                        _this.modelSC.subscription.price2 = { discount: elem.discount };
                        break;
                    case 2:
                        _this.modelSC.subscription.price3 = { discount: elem.discount };
                        break;
                    case 3:
                        _this.modelSC.subscription.price4 = { discount: elem.discount };
                        break;
                    case 4:
                        _this.modelSC.subscription.price5 = { discount: elem.discount };
                        break;
                    case 5:
                        _this.modelSC.subscription.price6 = { discount: elem.discount };
                        break;
                    case 6:
                        _this.modelSC.subscription.price7 = { discount: elem.discount };
                        break;
                    case 7:
                        _this.modelSC.subscription.price8 = { discount: elem.discount };
                        break;
                    case 8:
                        _this.modelSC.subscription.price9 = { discount: elem.discount };
                        break;
                    case 9:
                        _this.modelSC.subscription.price10 = { discount: elem.discount };
                        break;
                    case 10:
                        _this.modelSC.subscription.price11 = { discount: elem.discount };
                        break;
                }
            });
        }
        this.model.admin.company =
            this.model &&
                this.model.admin &&
                this.model.admin.company &&
                this.model.admin.company._id
                ? this.model.admin.company._id
                : undefined;
        this.model.owner =
            this.model && this.model.owner && this.model.owner._id
                ? this.model.owner._id
                : undefined;
        // Set fields
        this.anagraphicFields = [
            // ...this.anagraphicFields,
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12 col-md-6",
                        type: "autocomplete",
                        key: "admin.company",
                        templateOptions: {
                            customLabel: this.translateService.instant("properties.fields.admin"),
                            placeholder: this.translateService.instant("properties.fields.admin"),
                            required: true,
                            bindLabel: "name",
                            bindValue: "_id",
                            multiple: false,
                            search$: this.companiesService.getList.bind(this),
                            initialValues: initialAdminData,
                            hideSelected: true,
                            disabled: this.loggedUserMaster,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant("common.words.typeToSearch", { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant("common.words.clearAll"),
                            notFoundText: this.translateService.instant("common.words.notFound"),
                            loadingText: this.translateService.instant("common.words.loading"),
                            callback: function (data) {
                                _this.onAdminCompanySelected(data);
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "autocomplete",
                        key: "owner",
                        templateOptions: {
                            customLabel: this.translateService.instant("properties.fields.owner"),
                            placeholder: this.translateService.instant("properties.fields.owner"),
                            required: false,
                            bindLabel: "name",
                            bindValue: "_id",
                            multiple: false,
                            search$: this.companiesService.getList.bind(this),
                            initialValues: initialOwnerData,
                            hideSelected: true,
                            // addTag: true,
                            disabled: this.loggedUserMaster,
                            minTermLength: minTermLength,
                            typeToSearchText: this.translateService.instant("common.words.typeToSearch", { minTermLength: minTermLength }),
                            clearAllText: this.translateService.instant("common.words.clearAll"),
                            notFoundText: this.translateService.instant("common.words.notFound"),
                            // addTagText: this.translateService.instant("common.words.addTag"),
                            loadingText: this.translateService.instant("common.words.loading"),
                        },
                    },
                    {
                        className: "col-12 col-md-4 col-xl-3",
                        type: "select",
                        key: "type",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.type"),
                            placeholder: this.translateService.instant("properties.fields.type"),
                            required: true,
                            disabled: this.loggedUserMaster,
                            options: [
                                {
                                    value: "co",
                                    label: this.translateService.instant("properties.types.co"),
                                },
                                {
                                    value: "bsc",
                                    label: this.translateService.instant("properties.types.bsc"),
                                },
                                {
                                    value: "pur",
                                    label: this.translateService.instant("properties.types.pur"),
                                },
                                {
                                    value: "puc",
                                    label: this.translateService.instant("properties.types.puc"),
                                },
                                {
                                    value: "sp",
                                    label: this.translateService.instant("properties.types.sp"),
                                },
                            ],
                        },
                    },
                    {
                        className: "col-12 col-md-4 col-xl-3",
                        type: "input",
                        key: "name",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.name"),
                            placeholder: this.translateService.instant("properties.fields.name"),
                            required: true,
                            disabled: this.loggedUserMaster,
                            minLength: 2,
                            maxLength: 100,
                        },
                    },
                    {
                        className: "col-12 col-md-4 col-xl-3",
                        type: "input",
                        key: "notifyMail1",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.notifyMail1"),
                            placeholder: this.translateService.instant("properties.fields.notifyMail1"),
                            required: true,
                            minLength: 5,
                            maxLength: 320,
                            type: "email",
                        },
                    },
                    {
                        className: "col-12 col-md-4 col-xl-3",
                        type: "input",
                        key: "notifyMail2",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.notifyMail2"),
                            placeholder: this.translateService.instant("properties.fields.notifyMail2"),
                            required: false,
                            minLength: 5,
                            maxLength: 320,
                            type: "email",
                        },
                    },
                    {
                        className: "col-12 col-md-12",
                        type: "address",
                        key: "address",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.address"),
                            placeholder: this.translateService.instant("properties.fields.address"),
                            required: false,
                            disabled: this.loggedUserMaster,
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "input",
                        key: "taxCode",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.taxCode"),
                            placeholder: this.translateService.instant("properties.fields.taxCode"),
                            required: true,
                            disabled: this.loggedUserMaster,
                            minLength: 0,
                            maxLength: 20,
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "input",
                        key: "sdiCode",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.sdiCode"),
                            placeholder: this.translateService.instant("properties.fields.sdiCode"),
                            required: false,
                            disabled: this.loggedUserMaster,
                            minLength: 6,
                            maxLength: 7,
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "day-month-picker",
                        key: "administrationStartDate",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.administrationStartDate"),
                            placeholder: this.translateService.instant("properties.fields.administrationStartDate"),
                            minLength: 2,
                            maxLength: 100,
                        },
                        modelOptions: {
                            updateOn: "change",
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "day-month-picker",
                        key: "administrationEndDate",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.administrationEndDate"),
                            placeholder: this.translateService.instant("properties.fields.administrationEndDate"),
                            minLength: 2,
                            maxLength: 100,
                        },
                        modelOptions: {
                            updateOn: "change",
                        },
                    },
                    {
                        className: "col-12 col-sm-6",
                        type: "input",
                        key: "iban",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.iban"),
                            placeholder: this.translateService.instant("properties.fields.iban"),
                            required: false,
                            minLength: 27,
                            maxLength: 27,
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "checkbox",
                        key: "dossier",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.dossier"),
                            placeholder: this.translateService.instant("properties.fields.dossier"),
                            required: false,
                            disabled: this.loggedUserMaster,
                        },
                    },
                    {
                        className: "col-12 col-sm-3",
                        type: "input",
                        key: "dossierEmail",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.dossierEmail"),
                            placeholder: this.translateService.instant("properties.fields.dossierEmail"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return _this.loggedUserMaster || !_this.model.dossier;
                            },
                            "templateOptions.required": function () {
                                return _this.model.dossier;
                            },
                        },
                    },
                ],
            },
        ];
        this.contractFields = [
            // 1. PLATFORM SUBSCRIPTION
            {
                fieldGroupClassName: "row",
                hooks: {
                    onInit: function () {
                        _this.updateSubscriptionCodes();
                    },
                },
                fieldGroup: [
                    {
                        className: "col-12 boxForm",
                        template: "<div><strong>" +
                            this.translateService.instant("companies.fields.subscription.subscription") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "checkbox",
                        key: "subscription.documentUpload",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.documentUpload.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.documentUpload.title"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "select",
                        key: "subscription.invoiceHolder",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.invoiceHolder.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.invoiceHolder.title"),
                            required: true,
                            multiple: false,
                            options: [
                                {
                                    value: "property",
                                    label: this.translateService.instant("companies.fields.subscription.invoiceHolder.property"),
                                },
                                {
                                    value: "admin",
                                    label: this.translateService.instant("companies.fields.subscription.invoiceHolder.admin"),
                                },
                                {
                                    value: "owner",
                                    label: this.translateService.instant("companies.fields.subscription.invoiceHolder.owner"),
                                },
                            ],
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit || !_this.modelSC.subscription.documentUpload);
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-4",
                        type: "select",
                        key: "subscription.key",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.subscriptionType"),
                            placeholder: this.translateService.instant("companies.fields.subscription.subscriptionType"),
                            multiple: false,
                            options: this.availableSubscriptionsKeys,
                            required: true,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit || !_this.modelSC.subscription.documentUpload);
                            },
                        },
                    },
                    {
                        className: "col-4",
                        type: "input",
                        key: "subscription.fee",
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.fee"),
                            placeholder: this.translateService.instant("subscriptions.fields.fee"),
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 10000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        _this.modelSC.subscription.key === "noSubscription"));
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-4",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "input",
                        key: "subscription.availableSpace",
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.availableSpace"),
                            placeholder: this.translateService.instant("subscriptions.fields.availableSpace"),
                            type: "number",
                            min: 0,
                            max: 1000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        _this.modelSC.subscription.key === "noSubscription"));
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "input",
                        key: "subscription.totalStorageSpaceUsed",
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.totalStorageSpaceUsed"),
                            placeholder: this.translateService.instant("subscriptions.fields.totalStorageSpaceUsed"),
                            // type: "number",
                            // step: 0.001,
                            // min: 0,
                            // max: 50000,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-0 col-md-4",
                    },
                ],
            },
            // 2. STRUCTURE SUBSCRIPTION
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.structure.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.structure",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.structure.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.structure.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription' && model.subscription.key !== 'FREE' && model.subscription.key !== 'FREEBASIC'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" ||
                                            _this.modelSC.subscription.key === "FREE" ||
                                            _this.modelSC.subscription.key === "FREEBASIC")));
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.structurePrice",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.structurePrice"),
                            placeholder: this.translateService.instant("companies.fields.subscription.structurePrice"),
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 10000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.structure",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" ||
                                            _this.modelSC.subscription.key === "FREE" ||
                                            _this.modelSC.subscription.key === "FREEBASIC" ||
                                            !_this.modelSC.subscription.structure)));
                            },
                        },
                    },
                ],
            },
            // 3. FIRST BALANCE
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.firstBalance.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.firstPriceList",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.firstPriceList.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.firstPriceList.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        _this.modelSC.subscription.key === "noSubscription"));
                            },
                        },
                    },
                    {
                        className: "col-1",
                    },
                ],
            },
            // 4. SUBSEQUENT INSERTIONS
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.subsequentInsertions.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.scanInsNext",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.scanInsNext.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.scanInsNext.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" ||
                                            _this.modelSC.subscription.flatRate)));
                            },
                        },
                    },
                    {
                        className: "col-10",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.flatRate",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" ||
                                            _this.modelSC.subscription.scanInsNext)));
                            },
                        },
                    },
                    {
                        className: "col-2",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalDoc",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalDoc"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalDoc"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalPdf",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalPdf"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalPdf"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                ],
            },
            // 5. SUBSEQUENT SCANS
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.subsequentScans.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.scanNext",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.scanNext.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.scanNext.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" ||
                                            _this.modelSC.subscription.flatRateScan)));
                            },
                        },
                    },
                    {
                        className: "col-10",
                    },
                    {
                        className: "col-12 col-md-2",
                        type: "checkbox",
                        key: "subscription.flatRateScan",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRateScan.title"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRateScan.title"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSC.subscription.documentUpload ||
                                    (_this.modelSC.subscription.key &&
                                        (_this.modelSC.subscription.key === "noSubscription" ||
                                            _this.modelSC.subscription.scanNext)));
                            },
                        },
                    },
                    {
                        className: "col-10",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalA4",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalA4"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalA4"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalA3",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalA3"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalA3"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalA2",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalA2"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalA2"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-1",
                    },
                    {
                        className: "col-2",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalA1",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalA1"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalA1"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalA0",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalA0"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalA0"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.totalOutFormat",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.flatRate.totalOutFormat"),
                            placeholder: this.translateService.instant("companies.fields.subscription.flatRate.totalOutFormat"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            disabled: true,
                        },
                    },
                    {
                        className: "col-1",
                    },
                ],
            },
            // 6. SUBSCRIPTION OPTIONS
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.optionsNfc.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "checkbox",
                        key: "subscription.nfcAccess",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.nfcAccess"),
                            placeholder: this.translateService.instant("companies.fields.subscription.nfcAccess"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "input",
                        key: "subscription.nfcAccessFee",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.nfcAccessFee"),
                            placeholder: this.translateService.instant("companies.fields.subscription.nfcAccessFee"),
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 10000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.nfcAccess",
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit || !_this.modelSC.subscription.nfcAccess;
                            },
                        },
                    },
                    {
                        className: "col-md-4",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "datepicker",
                        key: "subscription.startDateNfcAccess",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.startDateNfcAccess"),
                            placeholder: this.translateService.instant("companies.fields.subscription.startDateNfcAccess"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.nfcAccess",
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit || !_this.modelSC.subscription.nfcAccess;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "datepicker",
                        key: "subscription.endDateNfcAccess",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.endDateNfcAccess"),
                            placeholder: this.translateService.instant("companies.fields.subscription.endDateNfcAccess"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.nfcAccess",
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit || !_this.modelSC.subscription.nfcAccess;
                            },
                        },
                    },
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.optionsSupplierEvaluation.sectionTitle") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "checkbox",
                        key: "subscription.suppliers",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.suppliers"),
                            placeholder: this.translateService.instant("companies.fields.subscription.suppliers"),
                            required: false,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "input",
                        key: "subscription.suppliersFee",
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.fee"),
                            placeholder: this.translateService.instant("subscriptions.fields.fee"),
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 10000,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.suppliers",
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-md-4",
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "datepicker",
                        key: "subscription.startDateSuppliers",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.startDateSuppliers"),
                            placeholder: this.translateService.instant("companies.fields.subscription.startDateSuppliers"),
                            disabled: true,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.suppliers",
                        },
                    },
                    {
                        className: "col-12 col-md-4",
                        type: "datepicker",
                        key: "subscription.endDateSuppliers",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.endDateSuppliers"),
                            placeholder: this.translateService.instant("companies.fields.subscription.endDateSuppliers"),
                            disabled: true,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.suppliers",
                        },
                    },
                    {
                        className: "col-md-8",
                    },
                ],
            },
            // 7. PRICE LIST
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.priceList.title") +
                            "</strong></div><br />",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12",
                        template: "<hr />",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12",
                        template: "<hr />",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("prices.types." + this.prices[index].name) +
                            "</div>",
                    },
                    {
                        key: "subscription.prices[" + index + "].key",
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index + "].price",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.price"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.priceService1"),
                            required: false,
                            type: "number",
                            step: 0.1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-12 col-md-3",
                        type: "input",
                        key: "subscription.prices[" + index++ + "].discount",
                        templateOptions: {
                            label: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            placeholder: this.translateService.instant("companies.fields.subscription.priceList.discount"),
                            required: false,
                            type: "number",
                            step: 1,
                            min: 0,
                            max: 100,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-0 col-md-6",
                    },
                    {
                        className: "col-12",
                        template: "<hr />",
                    },
                    {
                        className: "col-12 section-label sub-section-label",
                        template: "<div>" +
                            this.translateService.instant("companies.fields.subscription.additionalStorage.sectionTitle") +
                            "</div>",
                    },
                    {
                        className: "col-3",
                        type: "input",
                        key: "subscription.extraSpaceFee",
                        templateOptions: {
                            label: this.translateService.instant("subscriptions.fields.extraSpaceFee"),
                            placeholder: this.translateService.instant("subscriptions.fields.extraSpaceFee"),
                            type: "number",
                            min: 0,
                            max: 500,
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.subscription.key && model.subscription.key !== 'noSubscription'",
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    (_this.modelSC.subscription.key &&
                                        _this.modelSC.subscription.key === "noSubscription"));
                            },
                        },
                    },
                ],
            },
            // Notes
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("companies.fields.subscription.notes") +
                            "</strong></div>",
                    },
                    {
                        className: "col-12",
                        type: "textarea",
                        key: "subscription.notes",
                        templateOptions: {
                            rows: 5,
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                ],
            },
        ];
        this.statusFields = [
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.sag.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.sag.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.sag.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.sag.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.sag.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.sag.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.sag.date"),
                            disabled: true,
                        },
                    },
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.partialMapping.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.partialMapping.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.partialMapping.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.partialMapping.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.sag &&
                                        _this.modelSP.propertyStatus.sag.checked));
                            },
                        },
                    },
                ],
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.mappingConfirmed.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.mappingConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.mappingConfirmed.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.mappingConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "checkbox",
                        key: "propertyStatus.mappingConfirmed.otherActivity",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.otherActivity"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.otherActivity"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.mappingConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-4",
                        type: "input",
                        key: "propertyStatus.mappingConfirmed.otherActivityNote",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.otherActivityNote"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingConfirmed.otherActivityNote"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.mappingConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                ],
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.mappingCompleted.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.mappingCompleted.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.mappingCompleted.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.date"),
                            disabled: true,
                        },
                    },
                    {
                        className: "col-6",
                        type: "input",
                        key: "propertyStatus.mappingCompleted.username",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.user"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.mappingCompleted.user"),
                            disabled: true,
                        },
                    },
                ],
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.insertionConfirmed.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.insertionConfirmed.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.insertionConfirmed.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.insertionConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.insertionConfirmed.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.insertionConfirmed.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.insertionConfirmed.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.insertionConfirmed.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                ],
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.insertionCompleted.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.insertionCompleted.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.insertionCompleted.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.insertionCompleted.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.insertionCompleted.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.insertionCompleted.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.insertionCompleted.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.insertionCompleted.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.partialMapping &&
                                        _this.modelSP.propertyStatus.partialMapping.checked));
                            },
                        },
                    },
                ],
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.startDate.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.startDate.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.startDate.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.startDate.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.ceased &&
                                        _this.modelSP.propertyStatus.ceased.checked));
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.startDate.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.startDate.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.startDate.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    _this.modelSP.propertyStatus.startDate.disabled ||
                                    (_this.modelSP.propertyStatus &&
                                        _this.modelSP.propertyStatus.ceased &&
                                        _this.modelSP.propertyStatus.ceased.checked));
                            },
                        },
                    },
                ],
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.ceased.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.ceased.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.ceased.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.ceased.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.ceased.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.ceased.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                ],
            },
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-4",
                        type: "checkbox",
                        key: "propertyStatus.remapping.checked",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.remapping.checked"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.remapping.checked"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return !_this.enableEdit;
                            },
                        },
                    },
                    {
                        className: "col-2",
                        type: "datepicker",
                        key: "propertyStatus.remapping.date",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.remapping.date"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.remapping.date"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSP.propertyStatus.remapping.checked);
                            },
                        },
                    },
                    {
                        className: "col-6",
                        type: "input",
                        key: "propertyStatus.remapping.user",
                        templateOptions: {
                            label: this.translateService.instant("properties.fields.propertyStatus.remapping.user"),
                            placeholder: this.translateService.instant("properties.fields.propertyStatus.remapping.user"),
                        },
                        expressionProperties: {
                            "templateOptions.disabled": function () {
                                return (!_this.enableEdit ||
                                    !_this.modelSP.propertyStatus.remapping.checked);
                            },
                        },
                    },
                ],
            },
        ];
    };
    /**
     * Autofill subscription values based on subscription type changes
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.updateSubscriptionCodes = function () {
        var _this = this;
        var subscriptionControl = this.formSC.controls.subscription;
        // Control fields
        var documentUploadControl = this.formSC.controls.subscription.get("documentUpload");
        var keyControl = this.formSC.controls.subscription.get("key");
        var suppliersControl = this.formSC.controls.subscription.get("suppliers");
        var startDateSuppliersControl = this.formSC.controls.subscription.get("startDateSuppliers");
        var nfcAccessControl = this.formSC.controls.subscription.get("nfcAccess");
        var startDateNfcAccessControl = this.formSC.controls.subscription.get("startDateNfcAccess");
        // Value fields
        var feeField = subscriptionControl.get("fee");
        var availableSpaceField = subscriptionControl.get("availableSpace");
        var structureField = subscriptionControl.get("structure");
        var structurePriceField = subscriptionControl.get("structurePrice");
        var firstPriceListField = subscriptionControl.get("firstPriceList");
        var scanInsNextField = subscriptionControl.get("scanInsNext");
        var flatRateField = subscriptionControl.get("flatRate");
        var scanNextField = subscriptionControl.get("scanNext");
        var flatRateScanField = subscriptionControl.get("flatRateScan");
        var startDateSuppliersField = subscriptionControl.get("startDateSuppliers");
        var endDateSuppliersField = subscriptionControl.get("endDateSuppliers");
        var suppliersFeeField = subscriptionControl.get("suppliersFee");
        var nfcAccessField = subscriptionControl.get("nfcAccess");
        var startDateNfcAccessField = subscriptionControl.get("startDateNfcAccess");
        var endDateNfcAccessField = subscriptionControl.get("endDateNfcAccess");
        var extraSpaceFeeField = subscriptionControl.get("extraSpaceFee");
        // Option fields
        var codeField;
        if (this.contractFields && Array.isArray(this.contractFields)) {
            this.contractFields.forEach(function (el) {
                if (el.fieldGroup && Array.isArray(el.fieldGroup)) {
                    el.fieldGroup.forEach(function (subEl) {
                        switch (subEl.key) {
                            case "subscription.code":
                                codeField = subEl;
                                break;
                        }
                    });
                }
            });
        }
        if (keyControl) {
            keyControl.valueChanges
                .pipe(distinctUntilChanged(), startWith(keyControl.value))
                .subscribe(function (res) {
                if (!res) {
                    return;
                }
                var filteredCodes = [];
                filteredCodes = [];
                filteredCodes = _this.firstScanCodes.filter(function (code) {
                    return code.keys.includes(res);
                });
                filteredCodes = [];
                filteredCodes = [];
                filteredCodes = [];
                filteredCodes = _this.scanNextCodesForfait.filter(function (code) {
                    return code.keys.includes(res);
                });
                var index = -1;
                switch (res) {
                    case "noSubscription":
                    case "PRIVACY":
                        feeField.setValue(0);
                        availableSpaceField.setValue(0);
                        extraSpaceFeeField.setValue(0);
                        structurePriceField.setValue(0);
                        structureField.setValue(false);
                        firstPriceListField.setValue(false);
                        scanInsNextField.setValue(false);
                        flatRateField.setValue(false);
                        scanNextField.setValue(false);
                        flatRateScanField.setValue(false);
                        nfcAccessField.setValue(false);
                        break;
                    case "FULL":
                        index = _this.archediSubscriptions.findIndex(function (el) {
                            return el.key === "FULL";
                        });
                        structureField.setValue(true);
                        firstPriceListField.setValue(true);
                        scanInsNextField.setValue(false);
                        flatRateField.setValue(true);
                        scanNextField.setValue(true);
                        flatRateScanField.setValue(false);
                        break;
                    case "FULLBASIC":
                        index = _this.archediSubscriptions.findIndex(function (el) {
                            return el.key === "FULLBASIC";
                        });
                        structureField.setValue(true);
                        firstPriceListField.setValue(true);
                        scanInsNextField.setValue(true);
                        flatRateField.setValue(false);
                        scanNextField.setValue(true);
                        flatRateScanField.setValue(false);
                        break;
                    case "FREE":
                        index = _this.archediSubscriptions.findIndex(function (el) {
                            return el.key === "FREE";
                        });
                        structureField.setValue(false);
                        firstPriceListField.setValue(true);
                        scanInsNextField.setValue(false);
                        flatRateField.setValue(true);
                        scanNextField.setValue(true);
                        flatRateScanField.setValue(false);
                        break;
                    case "FREEBASIC":
                        index = _this.archediSubscriptions.findIndex(function (el) {
                            return el.key === "FREEBASIC";
                        });
                        structureField.setValue(false);
                        firstPriceListField.setValue(true);
                        scanInsNextField.setValue(true);
                        flatRateField.setValue(false);
                        scanNextField.setValue(true);
                        flatRateScanField.setValue(false);
                        break;
                }
                if (index > -1) {
                    feeField.setValue(_this.archediSubscriptions[index].fee);
                    availableSpaceField.setValue(_this.archediSubscriptions[index].availableSpace);
                    extraSpaceFeeField.setValue(_this.archediSubscriptions[index].extraSpaceFee);
                    structurePriceField.setValue(_this.archediSubscriptions[index].structurePrice);
                }
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
        if (suppliersControl) {
            suppliersControl.valueChanges
                .pipe(distinctUntilChanged(), startWith(suppliersControl.value))
                .subscribe(function (res) {
                if (!res) {
                    startDateSuppliersField.setValue(null);
                    endDateSuppliersField.setValue(null);
                    suppliersFeeField.setValue(null);
                }
                else {
                    startDateSuppliersField.setValue(_this.masterStarDateSupplier);
                    endDateSuppliersField.setValue(_this.masterEndDateSupplier);
                    suppliersFeeField.setValue(_this.masterSuppliersFee);
                }
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
        if (documentUploadControl) {
            documentUploadControl.valueChanges
                .pipe(distinctUntilChanged(), startWith(documentUploadControl.value))
                .subscribe(function (res) {
                if (res) {
                    nfcAccessControl.setValue(true);
                }
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
        if (startDateSuppliersControl) {
            startDateSuppliersControl.valueChanges
                .pipe(distinctUntilChanged(), startWith(startDateSuppliersControl.value))
                .subscribe(function (res) {
                if (!res) {
                    return;
                }
                if (res && startDateSuppliersField.dirty) {
                    // Set endDate automatically to startDate + 1 year
                    var start = new Date(res);
                    var end = start;
                    end.setDate(start.getDate() - 1);
                    end.setFullYear(end.getFullYear() + 1);
                    endDateSuppliersField.setValue(end);
                }
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
        if (startDateNfcAccessControl) {
            startDateNfcAccessControl.valueChanges
                .pipe(distinctUntilChanged(), startWith(startDateNfcAccessControl.value))
                .subscribe(function (res) {
                if (!res) {
                    return;
                }
                if (res && startDateNfcAccessField.dirty) {
                    // Set endDate automatically to startDate + 1 year
                    var start = new Date(res);
                    var end = start;
                    end.setDate(start.getDate() - 1);
                    end.setFullYear(end.getFullYear() + 1);
                    endDateNfcAccessField.setValue(end);
                }
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
    };
    /**
     * Init shared user form
     */
    PropertyCondominiumAccessComponent.prototype.initShareUserFom = function () {
        var _this = this;
        // Set model
        var propertyId = this.property.get("_id");
        // Use pre-saved adminCompanyId (saved before initForm can mutate it)
        var companyId = this.adminCompanyId;
        var userRoles = this.sharedUser.get("userRoles");
        var userRoleIndex;
        var propertiesPermissionUser = {};
        if (userRoles && Array.isArray(userRoles) && companyId) {
            userRoleIndex = userRoles.findIndex(function (elem) {
                return elem && elem.company && elem.company._id
                    ? elem.company._id.toString() === companyId.toString()
                    : false;
            });
        }
        var propertyPerm;
        if (userRoleIndex > -1) {
            propertiesPermissionUser = userRoles[userRoleIndex].propertiesPermission;
        }
        this.modelSharedUser = this.sharedUser;
        if (propertiesPermissionUser) {
            this.modelSharedUser.propertiesPermission = propertiesPermissionUser;
        }
        this.sharedUserFields = [
            {
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        fieldGroupClassName: "col",
                        className: "col-12 col-md-6 col-lg-4",
                        fieldGroup: [
                            {
                                key: "companyId",
                                defaultValue: companyId,
                            },
                            {
                                key: "propertyId",
                                defaultValue: propertyId,
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.unlimited",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.unlimited.label"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                key: "propertiesPermission.expiresUnlimited",
                                defaultValue: "unlimited",
                            },
                            {
                                template: "<div><strong>" +
                                    this.translateService.instant("users.fields.propertiesPermission.areaMappatura") +
                                    "</strong></div>",
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.mappatura",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.mappatura"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                template: "<br /><div><strong>" +
                                    this.translateService.instant("users.fields.propertiesPermission.areaGest") +
                                    "</strong></div>",
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.gestionaleAmministrativo",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.gestionaleAmministrativo"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.gestionaleContabile",
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.gestionaleContabile"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.urbanisticaEdEdilizia",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.urbanisticaEdEdilizia"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.catasto",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.catasto"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.contratti",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.contratti"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                template: "<br /><div><strong>" +
                                    this.translateService.instant("users.fields.propertiesPermission.areaUnitaImmob") +
                                    "<strong></div>",
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.unitaImmobiliari",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.unitaImmobiliari"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                        ],
                    },
                    {
                        className: "col-12 col-md-6 col-lg-4",
                        fieldGroupClassName: "col",
                        fieldGroup: [
                            {
                                template: "<br /><div><strong></strong></div>",
                            },
                            {
                                template: "<br /><div><strong>" +
                                    this.translateService.instant("users.fields.propertiesPermission.areaTecnica") +
                                    "</strong></div>",
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.lineaVita",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.lineaVita"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.amiantoDoc",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.amiantoDoc"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.edile",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.edile"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                // "Chiavi e codici" is a sub-section of the "Strutture" (edile) area:
                                // memberships saved before this flag existed have no value for it, so
                                // the checkbox must start unchecked instead of undefined.
                                type: "checkbox",
                                key: "propertiesPermission.chiaviECodici",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.chiaviECodici"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.impiantoElettrico",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.impiantoElettrico"),
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.riscaldamentoCondizionamento",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.riscaldamentoCondizionamento"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.ascensori",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.ascensori"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.trattamentoAcqua",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.trattamentoAcqua"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.impiantiElettronici",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.impiantiElettronici"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.antincendio",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.antincendio"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.impiantiSpeciali",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.impiantiSpeciali"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.impiantiRicreativiSportivi",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.impiantiRicreativiSportivi"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                            {
                                type: "checkbox",
                                key: "propertiesPermission.preventivi",
                                defaultValue: false,
                                templateOptions: {
                                    label: this.translateService.instant("users.fields.propertiesPermission.preventivi"),
                                },
                                expressionProperties: {
                                    "templateOptions.onClick": function (model, formState, field) {
                                        var key = field.key;
                                        var subKey = key.replace("propertiesPermission.", "");
                                        if (_this.previousPermissions[subKey] !=
                                            model.propertiesPermission[subKey]) {
                                            _this.previousPermissions[subKey] =
                                                model.propertiesPermission[subKey];
                                            _this.managePermissionCheckbox(model, field, subKey);
                                        }
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
        ];
    };
    /**
     * set/unset all permission checkbox on the unlimited permission change event
     */
    PropertyCondominiumAccessComponent.prototype.managePermissionCheckbox = function (model, field, subKey) {
        if (subKey !== "unlimited") {
            this.previousPermissions[subKey] = model.propertiesPermission[subKey];
            var allChkTrue = true;
            for (var property in model.propertiesPermission) {
                if (property !== "unlimited") {
                    allChkTrue = allChkTrue && model.propertiesPermission[property];
                }
            }
            if (allChkTrue) {
                this.previousPermissions.unlimited = false;
                model.propertiesPermission.unlimited = false;
                this.formSharedUser
                    .get("propertiesPermission.unlimited")
                    .setValue(true);
            }
            else {
                this.previousPermissions.unlimited = false;
                model.propertiesPermission.unlimited = false;
                this.formSharedUser
                    .get("propertiesPermission.unlimited")
                    .setValue(false);
            }
        }
        else {
            for (var property in model.propertiesPermission) {
                if (property !== "expiresUnlimited") {
                    if (typeof this.formSharedUser.value.propertiesPermission[property] !==
                        "undefined") {
                        this.formSharedUser
                            .get("propertiesPermission." + property)
                            .setValue(model.propertiesPermission.unlimited);
                        this.previousPermissions[property] =
                            model.propertiesPermission.unlimited;
                    }
                }
            }
            for (var property in model.properties) {
                if (property !== "expiresUnlimited") {
                    if (typeof this.formSharedUser.value.properties[property] !==
                        "undefined") {
                        this.formSharedUser
                            .get("properties." + property)
                            .setValue(model.propertiesPermission.unlimited);
                        //this.previousPermissions[property] = model.propertiesPermission.unlimited;
                    }
                }
            }
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.onFormSubmit = function (formNumber) {
        var _this = this;
        // Prevent invalid form submit
        if (formNumber === 1) {
            if (this.form.invalid) {
                Object.keys(this.form.controls).forEach(function (key) {
                    _this.form.controls[key].markAsTouched();
                });
                this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
                console.warn(this.form);
                return;
            }
        }
        if (formNumber === 2) {
            if (this.form.invalid || this.formSC.invalid) {
                Object.keys(this.form.controls).forEach(function (key) {
                    _this.form.controls[key].markAsTouched();
                });
                Object.keys(this.formSC.controls).forEach(function (key) {
                    _this.formSC.controls[key].markAsTouched();
                });
                this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
                console.warn(this.form);
                console.warn(this.formSC);
                return;
            }
        }
        this.modelSC.subscription.totalStorageSpaceUsed =
            this.previousTotalStorageSpaceUsed;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("properties.dialog.saveMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            // Remove blank values from model
            Object.keys(_this.model).forEach(function (key) {
                if (!_this.model[key] || _this.model[key].valueOf() === "") {
                    delete _this.model[key];
                }
            });
            Object.keys(_this.modelSC).forEach(function (key) {
                if (!_this.modelSC[key] || _this.modelSC[key].valueOf() === "") {
                    delete _this.modelSC[key];
                }
            });
            // Activate submit button loading status
            _this.formBtnOptions.active = true;
            var subscription;
            if (formNumber === 1) {
                subscription = _this.model.subscription
                    ? _this.model.subscription
                    : undefined;
                if (!subscription) {
                    _this.toastrService.error(_this.translateService.instant("common.errors.form_is_invalid"));
                    return;
                }
            }
            if (formNumber === 2) {
                subscription = _this.modelSC.subscription
                    ? _this.modelSC.subscription
                    : undefined;
                if (!subscription) {
                    _this.toastrService.error(_this.translateService.instant("common.errors.form_is_invalid"));
                    return;
                }
            }
            // START - Create balance details on subscriptions
            var description = "";
            var detail = [];
            if (subscription.documentUpload) {
                detail.push({
                    code: subscription.key,
                    description: description,
                    quantity: 1,
                    unitPrice: subscription.fee,
                    totalRow: subscription.fee,
                });
            }
            // structure
            if (subscription.structure &&
                subscription.key !== "FREE" &&
                subscription.key !== "FREEBASIC") {
                description = "";
                detail.push({
                    code: "",
                    description: description,
                    quantity: 1,
                    unitPrice: subscription.structurePrice,
                    totalRow: subscription.structurePrice,
                });
            }
            if (subscription.suppliers) {
                var sub = _this.configService.availableOptionsCodes.filter(function (el) {
                    return el.value === "SPL001";
                })[0];
                description = "";
                description =
                    sub && sub.description ? sub.description : "";
                description = description.replace(/\s\s+/g, " ");
                description = description.replace("#year#", moment(subscription.startDateSuppliers).year().toString());
                detail.push({
                    code: "SPL001",
                    description: description,
                    quantity: 1,
                    unitPrice: subscription.suppliersFee,
                    totalRow: subscription.suppliersFee,
                });
            }
            var newSubscription = tslib_1.__assign({}, subscription, { detail: detail });
            _this.model = tslib_1.__assign({}, _this.model, { subscription: newSubscription });
            // END - Create balance details on subscriptions
            _this.subscriptions.push(_this.propertiesService
                .update(_this.property.getId(), _this.model)
                .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                .subscribe(function (res) {
                if (res) {
                    _this.toastrService.success(res.message);
                    _this.enableEdit = false;
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        });
    };
    PropertyCondominiumAccessComponent.prototype.onFormStatusSubmit = function () {
        var _this = this;
        // Prevent invalid form submit
        if (this.formSP.invalid) {
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            console.warn(this.formSP);
            return;
        }
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("users.dialog.saveMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            // Remove blank values from model
            Object.keys(_this.modelSP).forEach(function (key) {
                if (!_this.modelSP[key] || _this.modelSP[key].valueOf() === "") {
                    delete _this.modelSP[key];
                }
            });
            var propertyStatus = _this.modelSP.propertyStatus;
            if (propertyStatus &&
                propertyStatus.mappingCompleted &&
                propertyStatus.mappingCompleted.user) {
                delete propertyStatus.mappingCompleted.username;
                propertyStatus.mappingCompleted.user =
                    _this.modelSP.propertyStatus.mappingCompleted.user._id;
            }
            var sendData = {
                propertyStatus: propertyStatus,
            };
            // Activate submit button loading status
            _this.formBtnOptions.active = true;
            _this.subscriptions.push(_this.propertiesService
                .updateFields(_this.propertyData._id, sendData)
                .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                .subscribe(function (res) {
                if (res) {
                    _this.toastrService.success(res.message);
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        });
    };
    PropertyCondominiumAccessComponent.prototype.onFormSharedUserSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.formSharedUser.invalid) {
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            console.warn(this.form);
            return;
        }
        if (model.userRoles &&
            Array.isArray(model.userRoles) &&
            model.userRoles.length) {
            if (model.userRoles[0].propertiesPermission &&
                model.userRoles[0].propertiesPermission.expiresUnlimited) {
                model.userRoles[0].propertiesPermission.expiresUnlimited = "unlimited";
            }
        }
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("users.dialog.saveMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        var property = this.formSharedUser.value.propertyId
            ? this.formSharedUser.value.propertyId
            : this.formSharedUser.controls.propertyId.value;
        if (property) {
            model.propertiesPermission.property = [];
            model.propertiesPermission.property.push(property);
        }
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            // Remove blank values from model
            Object.keys(model).forEach(function (key) {
                if (!model[key] || model[key].valueOf() === "") {
                    delete model[key];
                }
            });
            // Activate submit button loading status
            _this.formSharedUserBtnOptions.active = true;
            _this.subscriptions.push(_this.userService
                .updateFields(_this.sharedUser.getId(), model)
                .pipe(finalize(function () { return (_this.formSharedUserBtnOptions.active = false); }))
                .subscribe(function (res) {
                if (res) {
                    _this.toastrService.success(res.message);
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        });
    };
    /**
     * Set current user to inactive
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.onDelete = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("properties.detail.deleteTab.confirmDeletion.title"),
                message: this.translateService.instant("properties.detail.deleteTab.confirmDeletion.message"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.subscriptions.push(_this.propertiesService
                .delete(_this.property.getId())
                .pipe(finalize(function () { return (_this.deleteBtnOptions.active = false); }))
                .subscribe(function (res2) {
                _this.toastrService.success(res2.message);
                // Once the user is deleted, redirect to list
                _this.router.navigate([
                    _this.lang,
                    "app",
                    "properties",
                    "suspended",
                ]);
                return;
            }, function (err) {
                // Choose one of the following error handling
                // method. The first one shows a message right
                // under the form fields (if the form is properly
                // setted), the second one shows toastr
                // notifications for each error
                // this.helperService.handleFormError(this.passwordForm, err);
                _this.helperService.handleError(err);
            }));
        });
    };
    /**
     * Reactivate current user
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.onReactivate = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("properties.detail.deleteTab.confirmActivation.title"),
                message: this.translateService.instant("properties.detail.deleteTab.confirmActivation.message"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.subscriptions.push(_this.propertiesService
                .activate(_this.property.getId())
                .pipe(finalize(function () { return (_this.reactivateBtnOptions.active = false); }))
                .subscribe(function (res2) {
                _this.toastrService.success(res2.message);
                // Once the user is deleted, redirect to list
                _this.router.navigate([_this.lang, "app", "properties", "list"]);
                return;
            }, function (err) {
                // Choose one of the following error handling
                // method. The first one shows a message right
                // under the form fields (if the form is properly
                // setted), the second one shows toastr
                // notifications for each error
                // this.helperService.handleFormError(this.passwordForm, err);
                _this.helperService.handleError(err);
            }));
        });
    };
    /**
     * Toggle activation in all list elements
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.onToggleSelected = function (element) {
        var _this = this;
        if (!element.checked) {
            // Prevent invalid form submit
            if (this.form.invalid) {
                Object.keys(this.form.controls).forEach(function (key) {
                    _this.form.controls[key].markAsTouched();
                });
                this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
                element.source.toggle();
                return;
            }
        }
        this.enableEdit = element.checked;
    };
    /**
     * Subscribe to lists settings service to allow this list
     * to remember current filters once users navigate to another page.
     * In this way once user will come back to this page he will
     * have all previous settings (such as page number, page size, search, ...)
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.subscribeToListsSettings = function (name) {
        this.listsService.enable();
        this.subscriptions.push(this.listsService.listsSettings$.subscribe(function (settings) {
            if (settings.length) {
                // settings.forEach((setting: ListSetting) => {
                // });
            }
        }));
    };
    /**
     * Export properties in a file with given format
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.onExport = function (target, propertyId) {
        var _this = this;
        if (target && typeof propertyId !== "undefined") {
            // Handle export for missing/inserted documents
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileName_1 = this.translateService.instant("properties.list." + target) + " " + date;
            this.subscriptions.push(this.propertiesService.getDocExport(target, propertyId).subscribe(function (res) {
                var fileBlob = res;
                var blob = new Blob([fileBlob], {
                    type: "application/vnd.ms-excel",
                });
                FileSaver.saveAs(blob, fileName_1 + ".xlsx");
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
    };
    /**
     * Send shared user data by email
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.onSendByEmail = function () {
        var _this = this;
        if (!this.sharedUser) {
            this.toastrService.error(this.translateService.instant("common.errors.not_found"));
            return;
        }
        var propertyName = this.property.get("name");
        var address = this.property.get("address.route") + ", " + this.property.get("address.streetNumber") + " - " + this.property.get("address.postalCode") + " " + this.property.get("address.city");
        var bodyP1 = this.translateService.instant("properties.shared.email.p1", {
            ownerCompany: this.companyName,
            address: address,
        });
        var bodyP2 = this.translateService.instant("properties.shared.email.p2", {
            userName: this.sharedUser.get("email"),
            password: this.model.taxCode,
        });
        var bodyP3 = this.translateService.instant("properties.shared.email.p3");
        // Create predefined text with shared user data
        var subject = this.translateService.instant("properties.shared.email.subject", {
            propertyName: propertyName,
            address: address,
        });
        var body = bodyP1 + "\n\n" + bodyP2 + "\n\n" + bodyP3;
        // Open dialog
        var newMessageDialogRef = this.newMessageDialog.open(AddCommunicationDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                phonebook: this.property.get("phonebook")
                    ? this.property.get("phonebook")
                    : [],
                subject: subject,
                body: body,
                sendSharedUser: true,
            },
            disableClose: true,
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        newMessageDialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.toastrService.success(_this.translateService.instant("communications.add.sendedSuccessfully"));
        });
    };
    // Copy email from admin company
    PropertyCondominiumAccessComponent.prototype.onAdminCompanySelected = function (company) {
        var _this = this;
        if (!this.model.admin || !company) {
            return;
        }
        if (company) {
            if (company.email && company.email !== "") {
                var notifyMail1Control = this.form.controls.notifyMail1;
                notifyMail1Control.setValue(company.email);
            }
            if (company.subscription) {
                Object.keys(company.subscription).forEach(function (key) {
                    if (key === "startDateSuppliers") {
                        _this.masterStarDateSupplier = company.subscription[key];
                    }
                    if (key === "endDateSuppliers") {
                        _this.masterEndDateSupplier = company.subscription[key];
                    }
                    if (key === "suppliersFee") {
                        _this.masterSuppliersFee = company.subscription[key];
                    }
                });
            }
        }
    };
    /**
     * Prevent redirect to archive if structure is open
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.onGoToDocumentArchive = function () {
        if (!this.mappaturaOpen) {
            return;
        }
        this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.mappaturaOpen.title"),
                message: this.translateService.instant("dialogs.confirm.mappaturaOpen.message"),
                btnCancelText: this.translateService.instant("common.cta.close"),
                messageOnly: true,
            },
            width: "500px",
            disableClose: false,
        });
    };
    /**
     * Word contracts export
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.onExportContracts = function () {
        var dialogRef = this.dialog.open(ExportContractsDialogComponent, {
            minWidth: "50%",
            maxHeight: "98vh",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * RAS docs export in PDF format
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.onExportRAS = function () {
        var dialogRef = this.dialog.open(ExportRasDocsDialogComponent, {
            width: "700px",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * STATUS CARD
     */
    PropertyCondominiumAccessComponent.prototype.onStatusToggle = function (statusType, checked) {
        console.log(statusType);
        console.log(checked);
        statusType.checked = checked;
    };
    PropertyCondominiumAccessComponent.prototype.onDateUpdate = function (statusType, event) {
        var value = event.target.value;
        console.log(statusType, value);
    };
    /**
     * Export statements in a file with given format
     *
     * @since 1.0.0
     */
    PropertyCondominiumAccessComponent.prototype.onStatementExport = function () {
        var _this = this;
        var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
        var fileName = this.translateService.instant("properties.detail.statement.list.exportFileName") + " " + date;
        this.subscriptions.push(this.statementsService.getExport(this.propertyId).subscribe(function (res) {
            var fileBlob = res;
            var blob = new Blob([fileBlob], {
                type: "application/vnd.ms-excel",
            });
            FileSaver.saveAs(blob, fileName + ".xlsx");
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    return PropertyCondominiumAccessComponent;
}());
export { PropertyCondominiumAccessComponent };
